import { useState } from 'react';
import { FileType } from './index';

const useFileUploader = (showPreview: boolean) => {
  const [selectedFiles, setSelectedFiles] = useState<FileType[]>([]);

  const handleAcceptedFiles = (
    acceptedFiles: FileType[],
    onFileUpload?: (files: FileType[]) => void,
    isSingleFile: boolean = false
  ) => {
    let filesToProcess = acceptedFiles.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );

    // Sadece tek dosya eklemesi durumunda sadece ilk dosyayı ekle
    if (isSingleFile) {
      filesToProcess = [filesToProcess[0]];
    }

    setSelectedFiles(showPreview ? filesToProcess : []);
    if (onFileUpload) onFileUpload(filesToProcess);
  };

  const removeFile = (file: FileType) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((f) => f.name !== file.name));
  };

  const formatBytes = (bytes: number, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  };

  return {
    selectedFiles,
    handleAcceptedFiles,
    removeFile,
  };
};

export default useFileUploader;
